import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TextMaskDirective } from './text-mask.directive';

const EXPOSED = [
	TextMaskDirective,
];

@NgModule({
	imports: [ CommonModule ],
	declarations: EXPOSED,
	exports: EXPOSED,
})
export class SharedFeaturesTextMaskModule { }
